document.addEventListener('wpcf7submit', function(event) {
    setTimeout(function() {
          jQuery('.wpcf7-form-control').removeClass('wpcf7-not-valid');
          jQuery('.wpcf7-not-valid-tip').hide();
          jQuery('.wpcf7-response-output').html('');

          
    }, 5000);
  
  }, false);